
const lineFit = function (points) {
    let sI = slopeAndIntercept(points);
    if (sI) {
        var N = points.length;
        var rV = [];
        rV.push([points[0][0], sI.slope * points[0][0] + sI.intercept]);
        rV.push([points[N - 1][0], sI.slope * points[N - 1][0] + sI.intercept]);
        return rV;
    }
    return [];
}

const slopeAndIntercept = function (points) {
    var rV = {},
        N = points.length,
        sumX = 0,
        sumY = 0,
        sumXx = 0,
        sumYy = 0,
        sumXy = 0;

    if (N < 2) {
        return rV;
    }

    for (var i = 0; i < N; i++) {
        var x = points[i][0],
            y = points[i][1];
        sumX += x;
        sumY += y;
        sumXx += (x * x);
        sumYy += (y * y);
        sumXy += (x * y);
    }
    rV['slope'] = ((N * sumXy) - (sumX * sumY)) / (N * sumXx - (sumX * sumX));
    rV['intercept'] = (sumY - rV['slope'] * sumX) / N;
    rV['rSquared'] = Math.abs((rV['slope'] * (sumXy - (sumX * sumY) / N)) / (sumYy - ((sumY * sumY) / N)));

    return rV;
}

const high_sort = (a, b) => {
    return a[1] - b[1];
}

// const low_sort = (a, b) => {
//     return b[1] - a[1];
// }

const getTrendLine = (data) => {
    let result = {};
    if (data !== undefined && data.length > 0) {

        let highPoints = [], lowPoints = [];
        //let midPoints = [], highPointList = [], lowPointList = [];
        //Daily Chart
        if (data[0].label !== undefined) {
            //data = data.slice(data.length - data.length * 0.3, data.length); //30 percent
            //let length = Math.round(data.length - (data.length * 0.4));
            let length = data.length - 150;            
            if (length < 0) {
                length = 0;
            }
            console.log('trendline data.lenght, lenght', data.length, length);
            for (var i = length; i < data.length; i++) {
                highPoints.push([i, data[i].high]);
                lowPoints.push([i, data[i].low]);
                //midPoints.push([i, (data[i].high + data[i].low) / 2]);
                //highPointList.push({loc: i, value: data[i].high});
            }
        } else {
            for (i = 0; i < data.length; i++) {
                highPoints.push([i, data[i].high]);
                lowPoints.push([i, data[i].low]);
                //midPoints.push([i, (data[i].high + data[i].low) / 2]);
                //lowPointList.push({loc: i, value: data[i].low});
            }
        }
        let highTrend = lineFit(highPoints);
        let lowTrend = lineFit(lowPoints);
        // let midTrend = lineFit(midPoints);
        //console.log('trendline highPoints1', highPointList, lowPointList);
        highPoints.sort(high_sort);
        //lowPoints.sort(low_sort);
        //console.log('trendline highPoints', highPoints, lowPoints);
        //let highTrend = highPoints.slice(highPoints.length-2,highPoints.length);
        //let lowTrend = lowPoints.slice(lowPoints.length-2,lowPoints.length);

        //console.log('trendline highTrend', data, highPoints, highTrend, lowTrend);
//        let adjust = highPoints.slice(highPoints.length-1,highPoints.length);
//        adjust = Math.round(adjust[0][1] - highTrend[1][1]);
        let adjust = 0;
        let lastPrice = data[data.length-1].close;
        console.log('trendline lastPrice', lastPrice);
        if (lastPrice <= 10){
            adjust = 0;
        } else if (lastPrice <=20){
            adjust = 1;
        } else if (lastPrice <= 30) {
            adjust = 2;
        } else if (lastPrice <= 60) {
            adjust = 3
        } else if (lastPrice <= 100) {
            adjust = 5;
        } else if (lastPrice <= 200) {
            adjust = 10;            
        } else if (lastPrice >200 && lastPrice <=1000) {
            adjust = 15;
        } else if (lastPrice >1000 && lastPrice <=2000) {
            adjust = 100;
        } else if (lastPrice > 3000) {
            adjust = 200;
        }

        result = [{
            'highTrend': highTrend,
            'lowTrend': lowTrend,
            //'midTrend': midTrend
            'adjust' : adjust
        }] 
    }
    return result;
}


export { getTrendLine };